export default __webpack_public_path__ + "static/media/check-circle.346ef7db.svg";